import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.addPatientCode, {type, payload}){
    switch(type){
        case types.ADD_NEW_PATIENT:
            return {
                isLoading: true,
                isStatus: 'request',
                request: payload,
                response: {},
            };
        case types.ADD_NEW_PATIENT_SUCCESS:
            return{
                ...state,
                isLoading: false,
                isStatus: 'success',
                response: payload,
            };
        case types.ADD_NEW_PATIENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                response: payload,
            };
        default:
            return state;
    }
}